import { Component, OnInit, ViewChild, Injector } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { Observable } from 'rxjs/Rx';
import { startWith, map } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { DocumentoNegociableService } from '../../../services/documento-negociable/documento-negociable.service';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';
import { ProformaService } from '../../../services/operaciones/proforma/proforma.service';
import { OperacionService } from '../../../services/operaciones/operacion/operacion.service';
import { SolicitudDesembolsoService } from '../../../services/operaciones/solicitud-desembolso/solicitud-des.service';
import { DesembolsoService } from '../../../services/tesoreria/desembolso/desembolso.service';
import { environment } from 'environments/environment';


export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MM-YYYY"
  },
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

declare var $: any;
@Component({
  selector: 'app-listado-proformas',
  templateUrl: './listado-proformas.component.html',
  styleUrls: ['./listado-proformas.component.scss'],
  providers: [MessagesTitles, MessagesGeneral, MessagesDates,
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class ListadoProformasComponent implements OnInit {

  Label_Proveedor = environment.LABEL_PROVEEDOR;
  Label_Proveedores = environment.LABEL_PROVEEDORES;
  Label_Adquirente = environment.LABEL_ADQUIRENTE;
  Label_Adquirentes = environment.LABEL_ADQUIRENTES;
  Label_Proforma = environment.LABEL_PROFORMA;
  Label_Proformas = environment.LABEL_PROFORMAS;
  Label_id_soles = environment.ID_GUIA_SOLES;
  Label_id_dolares = environment.ID_GUIA_DOLARES;
  idProforma: number;
  fechaDop: Date = new Date();
  fechaHop: Date = new Date();
  flagProformaDetalle: boolean = false;
  estado: string = "R";
  idProv = "";
  idAdq = "";
  user: any;
  form: FormGroup;
  ruc = new FormControl('');
  rucAdq = new FormControl('');
  filteredProveeedor: Observable<any[]>;
  proveedoresArr;
  filteredAdquirentes: Observable<any[]>;
  adquirentessArr;
  loading: boolean;
  proforma: any = [];
  docNegociables: any = [];
  dataSource: any;
  user_id: any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = [15, 20, 30, 50, 100, 200];
  displayedColumns: string[] = ['checked', 'idProforma', 'NombreComercialProv', 'NombreComercialAdq', 'Registro', 'TipoMoneda', 'VNPP', 'Fecha_Vigencia', 'Cantidad_de_Documentos_Negociables', 'Estado'];

  operacionService: OperacionService;

  constructor(
    private proformaService: ProformaService,
    private injector: Injector,
    private documentoNegociableService: DocumentoNegociableService,
    private solicitudDesembolsoService: SolicitudDesembolsoService,
    private desembolsoService: DesembolsoService,
    private datePipe: DatePipe) {

    this.operacionService = this.injector.get<OperacionService>(OperacionService);
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.fechaDop.setDate(this.fechaDop.getDate() - 60);
    this.ObtenerProveedoresCombo();
    this.ObtenerAdquirentesCombo();
  }

  ngOnInit() {
    this.ListadoProformaFiltros();
  }

  MetCerrarProformaDetalle() {
    this.flagProformaDetalle = false;
  }

  obtenerpdf(urlPdf) {
    Swal.fire({
      title: '',
      text: '¿Desea descargar la cotización en PDF?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, descargar PDF.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        window.open(urlPdf, "_blank");
      }
    });
  }

  ListadoProformaFiltros() {
    this.loading = true;
    /*  this.user_id=Buffer.from(this.user.id_user.toString()).toString('base64'); */
    if (this.ruc.value == null || this.ruc.value == "") {
      this.idProv = "";
    }
    if (this.rucAdq.value == null || this.rucAdq.value == "") {
      this.idAdq = "";
    }

    this.proformaService.obtenerProformas(this.idAdq, this.idProv, this.estado, this.datePipe.transform(this.fechaDop, 'yyyy-MM-dd'), this.datePipe.transform(this.fechaHop, 'yyyy-MM-dd'), this.user_id)
      .subscribe(
        res => {
          this.proforma = res;
          this.dataSource = new MatTableDataSource(this.proforma);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.loading = false;
        }, err => {
          Swal.fire({
            title: "Datos incompletos",
            text: "Coordine con el departamento de contabilidad.",
            allowOutsideClick: true,
            heightAuto: false
          });
          this.loading = false;
        }
      );
  }

  private _filterProv(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.proveedoresArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  ObtenerProveedoresCombo() {
    this.proveedoresArr = JSON.parse(sessionStorage.getItem('lstProvCbo'));
    this.filteredProveeedor = this.ruc.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterProv(state) : this.proveedoresArr.slice()
        )
      );
  }

  ObtenerAdquirentesCombo() {
    this.adquirentessArr = JSON.parse(sessionStorage.getItem('lstAdqCbo'));
    this.filteredAdquirentes = this.rucAdq.valueChanges
      .pipe(
        startWith(""),
        map(state =>
          state ? this._filterAdq(state) : this.adquirentessArr.slice()
        )
      );
  }

  obtenerRucRazSocialAdq(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.adquirentessArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idAdq = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  obtenerRucRazSocialProv(termino: string = '') {
    if (termino != null && termino != '') {
      let termino1 = termino.toLowerCase();
      for (let p of this.proveedoresArr) {
        let raz = p.Razon_Social.toLocaleLowerCase();
        if (raz.indexOf(termino1) >= 0) {
          this.idProv = p.Num_Doc_Identificacion;
        }
      }
    }
  }

  obtenerRucProv(termino: string) {
    this.idProv = termino;
  }

  obtenerRucAdq(termino: string) {
    this.idAdq = termino;
  }

  enviarIdProforma(idProforma: number) {
    this.idProforma = idProforma;
    this.flagProformaDetalle = true;
  }

  private _filterAdq(value: string): any[] {
    const filterValue = value.toString().toLowerCase();
    return this.adquirentessArr.filter(
      state => state.Razon_Social.toLowerCase().includes(filterValue) === true
    );
  }

  darBajaProforma(idProforma) {
    Swal.fire({
      title: '¡Advertencia!',
      text: '¿Está seguro de cancelar la cotización?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, cancelar.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere...',
          html: 'Processing request.',
          heightAuto: false
        });
        Swal.showLoading();
        this.form = new FormGroup({
          'idProforma': new FormControl(idProforma),
          'Estado': new FormControl('B'),
          'Baja_Canal': new FormControl('W'),
          'Baja_Usuario': new FormControl(this.user.Usuario)
        });
        this.proformaService.bajaProforma(this.form.getRawValue()).subscribe(
          res => {
            this.actualizarDocumentosN(idProforma);
            this.ListadoProformaFiltros();
            Swal.fire({
              title: '¡Éxito!',
              text: this.Label_Proforma + ' cancelado correctamente.',
              type: 'success',
              heightAuto: false
            });
          },
          err => {
            Swal.fire({
              title: "Error",
              text: "",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          })
      }
    });
  }

  AceptarProforma(idProforma, Tipo_Servicio = 0) {
    Swal.fire({
      title: '',
      text: '¿Está seguro de aprobar la cotización?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, aprobar.',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: 'Espere...',
          html: 'Processing request.',
          heightAuto: false
        });
        Swal.showLoading();
        this.form = new FormGroup({
          'idProforma': new FormControl(idProforma),
          'Estado': new FormControl('A'),
          'Baja_Canal': new FormControl('W'),
          'Baja_Usuario': new FormControl(this.user.Usuario)
        });
        this.proformaService.bajaProforma(this.form.getRawValue()).subscribe(
          res => {
            Swal.fire({
              title: '¡Éxito!',
              text: 'La cotización se aprobó correctamente.',
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value == true) {

                /*REGISTRO OPERACION */
                if (Tipo_Servicio == 1485) {
                  let dataOpe = {
                    'idProforma': idProforma,
                    'idUsuario': '379',
                    'idRepresentanteProv1': '2529',
                    'idRepresentanteProv2': '',
                    'idRepresentanteIF': '00',
                    'idCuenta': '1789',
                    'bancoDetalle': '00',
                    'Tipo_Servicio': '1485',
                    'Porcentaje_Interes_Adquirente': '0',
                  }
                  this.operacionService.guardarOperacion(dataOpe).subscribe(
                    res => {
                      let Ope: any = res;
                      /*REGISTRO Solicitud de desembolso */
                      let body: any = { 'SolicitudDesembolso': [] };
                      let dataSolDes = {
                        'idOperacion': Ope.idOperacion,
                        'Adelanto_A_Ejecutar': Ope.Adelanto_importe,
                        'Usuario': 'robot'
                      }
                      body.SolicitudDesembolso.push(dataSolDes);
                      this.solicitudDesembolsoService.crearSoliDes(body).subscribe(
                        res2 => {
                          let Sol: any = res2;
                          /*REGISTRO DE PLANILLA */
                          /*let solicitudDes :any = [];
                          solicitudDes.push(Sol[0].Model.idSolicitudDesembolso);
                          let dataPlanilla = {
                            'Tipo_de_planilla':'1337',
                            'Moneda':Ope.Moneda,
                            'Alta_Usuario':'robot',
                            'Importe':Sol[0].Model.Desembolso_Importe,
                            'idSolicitudDesembolso':solicitudDes,
                          }
                          this.desembolsoService.crearDesembolso(dataPlanilla).subscribe(
                            res=>{
                              
                            }
                          );*/
                          /*FIN REGISTRO DE PLANILLA */
                        }
                      );
                      /*FIN REGISTRO Solicitud de desembolso */
                    }
                  )
                }
                /*FIN REGISTRO OPERACION */

                this.ListadoProformaFiltros();
              }
            });
          },
          err => {
            Swal.fire({
              title: "Error",
              text: "No se pudo aprobar la cotización.",
              type: "error",
              allowOutsideClick: false,
              heightAuto: false
            });
          });
      }
    });
  }

  actualizarDocumentosN(idProforma) {
    let docs: any;
    let randon = "";
    let cont: number = 0;
    let contE: number = 0;
    let total: number = 0;
    let body: any = { 'Estado': "V" };
    this.proformaService.obtenerProformaDetalle(idProforma).subscribe(
      res => {
        docs = res;
        total = docs.length;
        for (let item of docs) {
          this.documentoNegociableService.actualizarDocNegociable(body, item.idComprobante).subscribe(
            res1 => {
              cont += 1;
              if (cont == 3) {
                randon = item.idComprobante;
              }
              if (cont <= 2) {
                this.showNotification('success', 'top', 'right', 'Documento ' + item.idComprobante + ' ha sido liberado.');
              } else if (cont + contE == total) {
                cont = cont - 2;
                if (cont == 1) {
                  this.showNotification('success', 'top', 'right', 'Documento ' + item.idComprobante + ' ha sido liberado.');
                } else {
                  this.showNotification('success', 'top', 'right', 'Another ' + cont + ' documentos han sido liberados.');
                }
              }
            }, err => {
              let error = "";
              contE += 1;
              error = err.error.error;
              this.showNotification('danger', 'top', 'right', 'Documento ' + item.idComprobante + ' no ha sido liberado. \n Error: ' + error);
              if (cont + contE == total) {
                cont = cont - 2;
                if (cont > 0) {
                  if (cont == 1) {
                    this.showNotification('success', 'top', 'right', 'Documento ' + randon + ' ha sido liberado.');
                  } else {
                    this.showNotification('success', 'top', 'right', 'Another ' + cont + ' documentos han sido liberados.');
                  }
                }
              }
            }
          );
        }
      }
    );
  }

  showNotification(type, from, align, message) {

    $.notify({
      icon: "notifications",
      message: message
    }, {
      type: type,
      timer: 4000,
      placement: {
        from: from,
        align: align
      },
      template: '<div data-notify="container" class="col-xl-4 col-lg-4 col-11 col-sm-4 col-md-4 alert alert-{0} alert-with-icon" role="alert">' +
        '<button mat-button  type="button" aria-hidden="true" class="close mat-button" data-notify="dismiss">  <i class="material-icons">close</i></button>' +
        '<i class="material-icons" data-notify="icon">notifications</i> ' +
        '<span data-notify="title">{1}</span> ' +
        '<span data-notify="message">{2}</span>' +
        '<div class="progress" data-notify="progressbar">' +
        '<div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>' +
        '</div>' +
        '<a href="{3}" target="{4}" data-notify="url"></a>' +
        '</div>'
    });
  }

}